export const DATA_SUMMARY_SECTION_I18N_PREFIX = "features.topics.components.data_summary_section";

export const DATA_SUMMARY_SECTION_I18N_KEYS = {
  file_name:                     "file_name",
  file_size:                     "file_size",
  kb_label:                      "kb_label",
  columns:                       "columns",
  total_data_points:             "total_data_points",
  includes_missing_data_remarks: "includes_missing_data_remarks",
  no_source_remarks:             "no_source_remarks",
  no_relevant_columns_detected_remarks: "no_relevant_columns_detected_remarks",
  no_content_column_detected_remarks:   "no_content_column_detected_remarks",
  date_for_all_data_points:             "date_for_all_data_points",
  no_date_column_detected_remarks:      "no_date_column_detected_remarks",
  language:                             "language",
  file_size_exceeded_message:           "file_size_exceeded_message",
  rows_exceeded_message:                "rows_exceeded_message"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/DataSummarySectioni18nConstants.js